import { render, staticRenderFns } from "./MenuLR.vue?vue&type=template&id=21eeb419&scoped=true"
import script from "./MenuLR.vue?vue&type=script&lang=js"
export * from "./MenuLR.vue?vue&type=script&lang=js"
import style0 from "./MenuLR.vue?vue&type=style&index=0&id=21eeb419&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eeb419",
  null
  
)

export default component.exports